import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { Marketplace } from '@spike/marketplace-model';
import { BusinessSettingsMarketplaceContext } from './businessSettingsMarketplaceContext';

export const useMarketplace = (): Marketplace => {
    const inBusinessSettings = useContext(BusinessSettingsMarketplaceContext);
    const marketplace = useSelector<RootState, Marketplace>(state =>
        inBusinessSettings ? state.marketplace.settingsMarketplace : state.marketplace.marketplace
    );
    return marketplace;
};

export default useMarketplace;
